<template>
  <el-dialog
    title="修改密码"
    :visible.sync="dialogVisible"
    width="450px"
    :close-on-click-modal="false"
  >
    <el-form
      ref="passwordForm"
      :model="passwordForm"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="工号">
        <el-input v-model="passwordForm.username" disabled placeholder="工号" />
      </el-form-item>
      <el-form-item label="当前密码" prop="oldPassword">
        <el-input
          v-model="passwordForm.oldPassword"
          type="password"
          show-password
          placeholder="请输入当前密码"
        />
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="passwordForm.newPassword"
          type="password"
          show-password
          placeholder="请输入新密码"
        />
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input
          v-model="passwordForm.confirmPassword"
          type="password"
          show-password
          placeholder="请再次输入新密码"
        />
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">确定提交</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { changePassword } from '@/api/auth'

export default {
  name: 'ChangePasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateNewPassword = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }
      if (value.length < 8 || value.length > 20) {
        callback(new Error('密码长度必须为8-20位'))
        return
      }
      let categoryCount = 0
      if (/[A-Z]/.test(value)) categoryCount++
      if (/[a-z]/.test(value)) categoryCount++
      if (/[0-9]/.test(value)) categoryCount++
      if (/[^A-Za-z0-9]/.test(value)) categoryCount++
      if (categoryCount < 3) {
        callback(new Error('密码必须包含大写字母、小写字母、数字、特殊字符中的至少三类'))
      } else {
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      passwordForm: {
        username: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      loading: false,
      rules: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validateNewPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.passwordForm.username = (this.$store.getters.user && this.$store.getters.user.username) || ''
  },
  watch: {
    visible(val) {
      if (val) {
        this.passwordForm.username = (this.$store.getters.user && this.$store.getters.user.username) || ''
        this.passwordForm.oldPassword = ''
        this.passwordForm.newPassword = ''
        this.passwordForm.confirmPassword = ''
        this.$nextTick(() => {
          if (this.$refs.passwordForm) {
            this.$refs.passwordForm.clearValidate()
          }
        })
      }
    }
  },
  methods: {
    handleCancel() {
      this.resetForm()
      this.$emit('update:visible', false)
    },
    handleSubmit() {
      this.$refs.passwordForm.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const res = await changePassword({
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          })
          const response = res.data || res
          if (response.code === 200) {
            this.$message.success(response.message || '密码修改成功')
            this.resetForm()
            this.$emit('update:visible', false)
          } else {
            this.$message.error(response.message || '密码修改失败')
          }
        } catch (error) {
          this.$message.error('修改密码失败，请重试')
        } finally {
          this.loading = false
        }
      })
    },
    resetForm() {
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.resetFields()
      }
      this.passwordForm.oldPassword = ''
      this.passwordForm.newPassword = ''
      this.passwordForm.confirmPassword = ''
    }
  }
}
</script>

<style scoped>
</style>
